import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Row from '../common/Row'

export default class SettingRow extends Row {
    render() {
        return (
                <tr className={this.props.childrenClass != '' ? this.props.childrenClass : 'default'}>
                    {this.props.header.map((item, i) =>{
                        if(item.type == 'array'){
                                return(
                                        <td key={i}>
                                                {this.props.data[item.name].map((v, i) => 
                                                        <span key={i}><span className={v.slug == 'houjin' ? 'text-pink' : 'text-teal'}>{ v.name }</span>&nbsp;</span>
                                                )}
                                        </td>
                                )
                        } else if (item.type == 'action') {
                                return(
                                        <td key={i}>
                                                { (item.elements.indexOf('view') > -1 && item.view_except_ids.indexOf(this.props.data['id']) == -1 ) ? (
                                                    <span><i onClick={this.handleView} className="material-icons md-18 clickable">pageview</i>　</span>
                                                ) : ''
                                                }
                                                { (item.elements.indexOf('edit') > -1 && item.edit_except_ids.indexOf(this.props.data['id']) == -1 ) ? (
                                                    <span><i onClick={this.handleEdit} className="material-icons md-18 clickable">edit</i>　</span>
                                                ) : ''
                                                }
                                                { (item.elements.indexOf('delete') > -1 && item.delete_except_ids.indexOf(this.props.data['id']) == -1 ) ? (
                                                    <span><i onClick={this.handleDelete} className="material-icons md-18 clickable">delete</i>　</span>
                                                ) : ''
                                                }
                                        </td>
                                )
                        } else if (item.type == 'date') {
                                return(
                                        <td key={i}>{ this.formatDate(this.props.data[item.name], 'Y年M月D日') }</td>
                                )
                        } else if (item.type == 'link_client_id') {
                                return(
                                        <td key={i}>
                                            <a className="text-primary" href={this.props.data[item.name] ? "/accounts/edit/" + this.props.data[item.name] : ''}>{this.props.data[item.name]}</a>
                                        </td>
                                        )
                        } else {
                                return(
                                        <td key={i}>
                                                { (this.props.childrenClass && item.name == 'title') ? (
                                                        <span>　　　{this.props.data[item.name]}</span>
                                                ) : (
                                                        <span>{this.props.data[item.name]}</span>
                                                        )
                                                }
                                        </td>
                                )
                                }
                        })
                    }
                </tr>
                );
    }
}